import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconWifi: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.9 4C15.6 4 19.1 5.5 21.7 8.2C22.1 8.6 22.1 9.2 21.7 9.6C21.5 9.8 21.3 9.9 21 9.9C20.8 9.9 20.5 9.8 20.3 9.6C18 7.3 15 6 11.9 6C8.8 6 5.9 7.2 3.7 9.5C3.3 9.9 2.7 9.9 2.3 9.5C1.9 9.1 1.9 8.5 2.3 8.1C4.9 5.4 8.3 4 11.9 4ZM5.5002 10.7C7.2002 9 9.5002 8 11.9002 8C14.4002 8 16.8002 9 18.5002 10.8C18.9002 11.2 18.9002 11.8 18.5002 12.2C18.3002 12.4 18.1002 12.5 17.8002 12.5C17.6002 12.5 17.3002 12.4 17.1002 12.2C15.7002 10.8 13.8002 10 11.9002 10C10.0002 10 8.3002 10.7 6.9002 12.1C6.5002 12.5 5.9002 12.5 5.5002 12.1C5.1002 11.7 5.1002 11.1 5.5002 10.7ZM13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5ZM8.3 13.3996C7.9 13.7996 7.9 14.3996 8.3 14.7996C8.7 15.1996 9.3 15.1996 9.7 14.7996C11 13.5996 13 13.5996 14.3 14.7996C14.5 14.9996 14.7 15.0996 15 15.0996C15.3 15.0996 15.5 14.9996 15.7 14.7996C16.1 14.3996 16.1 13.7996 15.7 13.3996C13.6 11.4996 10.3 11.4996 8.3 13.3996Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
